import React from 'react';
import styled from 'styled-components';
const MainImage = require('../../assets/underDevelopment.png');

const Maintenance = () => {
  return (
    <Wrapper>
      <div>
        <MainImg alt='System under maintenance' src={MainImage} />
        <Title>
          SYSTEM MAINTENANCE
        </Title>
        <Content>
          Unfortunately the website is down for maintenance right now. We will be back shortly.
          Please check again soon. Thanks.
        </Content>
        <a href='/'>Refresh to Homepage</a>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  text-align: center;
  width: 100vw;
  height: 100vh;
  background-color: white;

  > div {
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
  }
`;

const MainImg = styled.img`
  max-width: 550px;
`;

const Title = styled.div`
  font-family: Roboto, sans-serif;
  font-size: 30px;
  font-weight: bold;
  margin-top: 20px;
`;

const Content = styled.div`
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-weight: normal;
  max-width: 758px;
  margin: 20px auto;
`;

export default Maintenance;
